export default class EditStudentAccountController {
    // @ngInject
    constructor(targetUser, schoolId) {
        this.targetUser = targetUser;
        this.schoolId = schoolId;
    }
}
